import React, { useContext, useMemo, FC, Fragment } from "react";
import { FiltersContext } from "../context/FiltersProvider";
import FilterBadge from "./FilterBadge";
import { FilterType } from "../types";

const ActiveFilters: FC = () => {
  const { filters } = useContext(FiltersContext);
  const badges = useMemo(
    () =>
      Object.keys(filters)
        .filter((key) => filters[key].currentValue || filters[key].defaultValue)
        .map((key) => {
          const label = filters[key].formatter
            ? filters[key].formatter(
                filters[key].currentValue || filters[key].defaultValue
              )
            : filters[key].currentValue || filters[key].defaultValue;
          return (
            <FilterBadge
              key={key}
              type={key as FilterType}
              label={label}
              hasDefaultValue={!!filters[key].defaultValue}
              icon={filters[key].icon}
            />
          );
        }),
    [filters]
  );
  return <Fragment>{badges}</Fragment>;
};

export default ActiveFilters;



// WEBPACK FOOTER //
// ./src/share/components/Filters/components/ActiveFilters.tsx